import { render, staticRenderFns } from "./DeleteTrade.vue?vue&type=template&id=1f6398f4&scoped=true"
import script from "./DeleteTrade.vue?vue&type=script&lang=js"
export * from "./DeleteTrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6398f4",
  null
  
)

export default component.exports